import { Pipe, PipeTransform} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'booleanFormat',
    standalone: false
})
export class BooleanFormatPipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}


  transform(value: boolean): any {
    return (value ? 'Ja' : 'Nein');
  }
}
